// @flow
import React from 'react';
import { connect } from 'react-redux';
import {
  MdClose,
  MdDirections,
} from 'react-icons/lib/md';

import type { ID_TYPE } from '../../types/common';
import * as studentsActions from '../../actions/students';
import PopupHeader from '../PopupHeader';
import PopupHeaderLeftGroup from '../PopupHeaderLeftGroup';
import PopupHeaderTitle from '../PopupHeaderTitle';
import PopupHeaderRightGroup from '../PopupHeaderRightGroup';
import PopupCloseButton from '../PopupCloseButton';
import PopupContainer from '../PopupContainer';
import StudentSchedulingForm from './StudentSchedulingForm';


type StudentSchedulingPopupPropTypes = {
  studentId: ID_TYPE,
  onLoad: Function,
};

class StudentSchedulingPopup extends React.Component<StudentSchedulingPopupPropTypes> {
  componentDidMount() {
    const { onLoad } = this.props;
    onLoad();
  }

  render() {
    const { studentId } = this.props;

    return (
      <PopupContainer size="big">
        <PopupHeader>
          <PopupHeaderLeftGroup>
            <PopupHeaderTitle size="big" title="Programación de viajes" />
          </PopupHeaderLeftGroup>
          <PopupHeaderRightGroup>
            <PopupCloseButton
              size="medium"
              Icon={MdClose}
              tint="mediumGray"
              clearMargins
              isTransparent
              isOutlined
            />
          </PopupHeaderRightGroup>
        </PopupHeader>
        <StudentSchedulingForm studentId={studentId} />
      </PopupContainer>
    );
  }
}


export default connect(
  undefined,
  (dispatch, { studentId }) => ({
    onLoad() {
      dispatch(studentsActions.startFetchingAssignedStops(parseInt(studentId, 10)));
      dispatch(studentsActions.fetchStudentGatewaysStarted(parseInt(studentId, 10)));
    },
  }),
)(StudentSchedulingPopup);

// TODO: empty states, loading states, redux form, redux form initial values from state, delete row



// WEBPACK FOOTER //
// ./src/scripts/components/StudentSchedulingPopup/index.jsx